/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";

export type RenameAgentForm = {
  id: string;
  name: string;
};

/** @internal */
export type RenameAgentForm$Outbound = {
  id: string;
  name: string;
};

/** @internal */
export const RenameAgentForm$outboundSchema: z.ZodMiniType<
  RenameAgentForm$Outbound,
  RenameAgentForm
> = z.object({
  id: z.string(),
  name: z.string(),
});

export function renameAgentFormToJSON(
  renameAgentForm: RenameAgentForm,
): string {
  return JSON.stringify(RenameAgentForm$outboundSchema.parse(renameAgentForm));
}
